export const SEGMENT_KEY = process.env.NEXT_PUBLIC_SEGMENT_KEY
